import { iSupplierPaymentMethod } from "@sdk/supplier-payment-methods/supplier-payment-method-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { supplierPaymentMethodsDefaultQueryConfig } from "./supplier-payment-methods-default-query";

export const {
  slice: SupplierPaymentMethodsSlice,
  reducers: SupplierPaymentMethodsSliceReducer,
  actions: {
    setEntityQueryResults: setSupplierPaymentMethodsQueryResults,
    setEntity: setSupplierPaymentMethod,
    setEntities: setSupplierPaymentMethods,
    patchEntity: patchSupplierPaymentMethod,
    addNewEntity: addNewSupplierPaymentMethod,
    setEntityFetchingStatus: setSupplierPaymentMethodFetchingStatus,
    setEntitiesFetchingStatus: setSupplierPaymentMethodsFetchingStatus,
    setEntityFailedStatus: setSupplierPaymentMethodFailedStatus,
    setEntityQueryError: setSupplierPaymentMethodsQueryError,
    resetQuery: resetSupplierPaymentMethodsQuery,
    setQueryList: setSupplierPaymentMethodQueryList,
  },
} = CreateEntitySlice<iSupplierPaymentMethod>({
  sliceName: "supplierPaymentMethods",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...supplierPaymentMethodsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
